import { endpoint } from "@services/api.services";
import Tooltip from "@ui/external/components/tooltip";
import { useHandleAction } from "@utils/hook/index.hook";
import { useSelectionStore } from "@utils/states/index.state";
import { useMemo } from "react";

const ColumnList = ({ refetch }: { refetch?: () => void }) => {
  const FaqEndpoint = useMemo(() => endpoint["faqs"], []);
  const { clearSelection } = useSelectionStore();
  console.log("Success", FaqEndpoint);
  const { handleAction } = useHandleAction({
    endpoint: FaqEndpoint,
    refetch,
  });
  const columns = useMemo(
    () => [
      {
        name: "ID",

        cell: (row: any) => (
          <span className="font-semibold text-gray-700">{row?.id}</span>
        ),
        sortable: true,
      },

      {
        name: "Question",
        cell: (row: any) => (
          <div className="flex items-center justify-start w-full h-full">
            {" "}
            <Tooltip description={row?.question}>
              <div className="text-sm font-medium flex items-start justify-start max-w-[250px] break-words whitespace-pre-wrap text-gray-800">
                {row?.question}
              </div>
            </Tooltip>
          </div>
        ),
        sortable: true,
      },
      {
        name: "Description",
        cell: (row: any) => (
          <div className="flex items-center justify-center w-full h-full">
            {" "}
            <Tooltip description={row?.description}>
              <div
                dangerouslySetInnerHTML={{ __html: row?.description }}
                className="text-sm font-medium flex items-start justify-start max-w-[250px] !h-10 break-words whitespace-pre-wrap overflow-hidden text-gray-800"
              ></div>
            </Tooltip>
          </div>
        ),
        sortable: true,
      },
      {
        name: "Actions",
        cell: (row: any) => (
          <div className="flex items-center gap-3 cursor-pointer font-[500] select-none">
            <button
              className="text-[#1DA077] cursor-pointer"
              onClick={() =>
                handleAction({ type: "modal-edit", data: row?.id })
              }
              title="Edit"
            >
              Edit
            </button>
            <button
              className="text-[#C33241] cursor-pointer"
              onClick={() => {
                clearSelection();
                handleAction({
                  type: "confirm",
                  data: { type: "delete", id: row?.id },
                });
              }}
              title="Delete"
            >
              Delete
            </button>
          </div>
        ),
        sortable: false,
      },
    ],
    [handleAction, clearSelection]
  );
  return columns;
};

export { ColumnList };
